module.exports = __webpack_public_path__ + "static/media/logo-10@2x.6c08981a.png";